import { initGrid } from 'utils/grid/grid';

import { fetchGameImages } from 'app/actions/game-images.actions';

import template from './games-selector.html';

const mapStateToThis = ({
  dirtyForms,
  gameImages,
  config,
}) => {
  const {
    isLoading,
    games,
  } = gameImages;
  const {
    defaultPageNo,
    sortColumnKey,
    pageSizeKey,
    directionKey,
  } = config;

  return {
    dirtyForms,
    games,
    isLoading,
    defaultPageNo,
    pageSizeKey,
    sortColumnKey,
    directionKey,
  };
};

const mapDispatchToThis = {
  fetchGameImages,
};

// eslint-disable-next-line no-undef
@Inject('$ngRedux')
class GameSelectorController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  async $onInit() {
    this.defaultParams = {
      [this.sortColumnKey]: 'gameNumber',
      [this.directionKey]: true,
      // eslint-disable-next-line max-len
      // Decision was made to start first with a big number if that won't fit users need we will have to adjust API to fetch all games at one time
      [this.pageSizeKey]: 5000,

    };

    this.gridModel = initGrid(this.fetchGameImages, this.defaultParams);
    this.gridModel.pagingModel.filters.type = this.gameType;
    this.gridModel.applyFilters();
  }


  $onDestroy() {
    this.unsubscribe();
  }
}

export default class GameSelectorComponent {
  constructor() {
    this.controller = GameSelectorController;
    this.template = template;
    this.bindings = {
      gameType: '<',
      gameNumber: '=',

    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/game-images/components/games-selector/games-selector-component.js